import { BadgeContainerElement, BadgeElement, BadgeWrapperContainerElement } from './style';
import { BadgeVariant } from './types';

export interface BadgeWrapperProps {
    children?: React.ReactChild;
    active?: boolean;
    content?: number | string;
    offset?: number;
    outline?: boolean;
    variant?: BadgeVariant;
}

export const Badge = ({
    active = true,
    content,
    children,
    offset,
    outline,
    variant = 'default',
    ...other
}: BadgeWrapperProps) => {
    const contentLength = typeof content === 'number' ? content.toString().length : content?.length;

    if (children) {
        return (
            <BadgeWrapperContainerElement data-test-badge-container {...other}>
                {children}
                {active && (
                    <BadgeContainerElement $offset={offset}>
                        <BadgeElement
                            $content={content}
                            contentLength={contentLength}
                            outline={outline}
                            data-test-badge
                            variant={variant}
                        >
                            {content}
                        </BadgeElement>
                    </BadgeContainerElement>
                )}
            </BadgeWrapperContainerElement>
        );
    }

    return (
        <BadgeElement contentLength={contentLength} outline={outline} data-test-badge variant={variant} {...other}>
            {content}
        </BadgeElement>
    );
};
